import { userAccount } from "../types/UserAccount";
import api from "./api";

const controller = "login";

export const handleLoginAuth = async (values: userAccount) => {
  const response = await api.post<any>(`api/${controller}`, values);
  return response;
};
